var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"above-menu"},[_vm._v("My Profile")]),_vm._v(" "),_c('nav',[_c('ul',[_c('router-link',{attrs:{"tag":"li","to":"/profile","exact":""}},[_vm._v("Profile")]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":"/profile/preferences"}},[_vm._v("Preferences")])],1)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa61db1a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfilePageMenu.vue
// module id = 12Zb
// module chunks = 1